<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(
            :color="toolbarColor"
            :dark="showButton"
          )
            v-toolbar-title FAQ
            v-spacer
            v-btn(
              elevation="1"
              v-if="showButton"
              @click="$router.push({ name: 'Login' })"
            ) Back
          v-divider
          //- TODO: UNTUK SAAT INI FAQ ADMIN BELUM DIPAKAI
          //- FaqAdmin(
          //-   :data='faqAdmin' 
          //-   v-if="$store.state.dataUsers.isAdmin"
          //- )
          FaqUsers(
            :data='faqUsers' 
          )
</template>

<script>
import * as faq from "../config/faq.json";
import FaqUsers from "@/components/FaqUsers.vue";
import FaqAdmin from "@/components/FaqAdmin.vue";
export default {
  name: "Faq",
  components: {
    FaqUsers,
    FaqAdmin
  },
  data () {
    return {
      faqUsers: faq.users,
      faqAdmin: faq.admin
    }
  },
  computed: {
    toolbarColor() {
      return this.$store.state.dataUsers && Object.keys(this.$store.state.dataUsers).length > 0 ? 'white' : 'red';
    },
    showButton() {
      return this.$store.state.dataUsers && Object.keys(this.$store.state.dataUsers).length > 0 ? false : true;
    }
  }
};
</script>
